import RequestPageMUI from "./RequestPageMUI";

const DanaLunchRequestsAnnual = () => {
    return (
        <RequestPageMUI
            title="Lunch - Annual Dana Requests"
            fetchUrl="/get-annual-dana-requests"
            editEndpoint="edit-annual-dana-request"
            deleteEndpoint="delete-annual-dana-request"
            statusEndpoint="annual-dana-request"
            dateFields={['created_at', 'updated_at', 'approved_at', 'rejected_at', 'deleted_at']}
            hiddenFields={['ip_address', 'deleted_at', 'member_id', 'member']}
            filterField="meal_type"
            filterValue="lunch"
            showFilter={false}
            serverSideSorting={true}
            enableColumnReorder={true}
            persistToDatabase={true}
            tableId="annual_dana_lunch"
        />
    );
};

export default DanaLunchRequestsAnnual;